import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "./../views/layout.vue";
import PageNotFound from './../views/errors/404.vue';

const existToken = (to, from, next) => {
  if (!["login", "otp-verification"].includes(from.name)) {
    next("404");
  }
  next();
};


Vue.use(VueRouter);

const routes = [
  {
    path: "/otp-verification",
    component: () => import("./../views/security/otp.vue"),
    name: "otp",
    beforeEnter: existToken,
  },
  {
    path: "/",
    component: Layout,
    meta: {
      auth: true
    },
    children: [
      {
        path: "",
        name: "dashboard",
        component: () => import("./../views/dashboard.vue"),
      },
      {
        path: "/users",
        name: "users",
        component: () => import("./../views/users/index.vue"),
        meta: {
          auth: {
            roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
          }
        }
      },
      {
        path: '/users/create',
        name: 'users-create',
        component: () => import('./../views/users/create.vue'),
        meta: {
          auth: {
            roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
          }
        }
      },
      {
        path: '/users/:id/edit',
        name: 'users-edit',
        component: () => import('./../views/users/edit.vue'),
        meta: {
          auth: {
            roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
          }
        }
      },
      {
        path: '/pushes/simple',
        name: 'pushes-simple',
        component: () => import('./../views/pushes/simple/index.vue')
      },
      {
        path: '/pushes/simple/:id/details',
        name: 'pushes-simple-details',
        component: () => import('./../views/pushes/simple/details.vue')
      },
      {
        path: '/pushes/simple/create',
        name: 'pushes-simple-create',
        component: () => import('./../views/pushes/simple/create.vue')
      },
      {
        path: '/pushes/advanced',
        name: 'pushes-advanced',
        component: () => import('./../views/pushes/advanced/index.vue')
      },
      {
        path: '/pushes/advanced/:id/details',
        name: 'pushes-advanced-details',
        component: () => import('./../views/pushes/advanced/details.vue')
      },
      {
        path: '/pushes/advanced/create',
        name: 'pushes-advanced-create',
        component: () => import('./../views/pushes/advanced/create.vue')
      },
      {
        path: "/provisions",
        name: "provisions",
        component: () => import("./../views/provisions/index.vue"),
      },
      {
        path: "/sms",
        name: "sms-sent",
        component: () => import("./../views/sms/sent/index.vue"),
      },
      {
        path: "/sms-queue",
        name: "sms-queue",
        component: () => import("./../views/sms/queue/index.vue"),
      },
      {
        path: "/servers",
        name: "servers",
        component: () => import("./../views/system/servers/index.vue"),
        meta: {
          auth: {
            roles: ['ROLE_SUPER_ADMIN']
          }
        }
      },
      {
        path: "/directories",
        name: "directories",
        component: () => import("./../views/system/directories/index.vue"),
        meta: {
          auth: {
            roles: ['ROLE_SUPER_ADMIN']
          }
        }
      },
      {
        path: "/files",
        name: "files",
        component: () => import("./../views/system/priorities/index.vue"),
        meta: {
          auth: {
            roles: ['ROLE_SUPER_ADMIN']
          }
        }
      },
      {
        path: "/archives",
        name: "archives",
        component: () => import("./../views/archives/index.vue"),
      },
      {
        path: "/account",
        name: "profile",
        component: () => import("./../views/users/profile.vue")
      },
      {
        path: "/developers",
        name: "developer",
        component: () => import("./../views/developers/index.vue"),
      },
      {
        path: "/developers/balance",
        name: "developer-balance",
        component: () => import("./../views/developers/balance.vue"),
      },
    ],
  },
  {
    path: "/login",
    component: () => import("./../views/security/login.vue"),
    name: "login",
  },
  {
    path: "/portail",
    component: () => import("./../views/security/portail.vue"),
    name: "portail",
  },
  {
    path: "/logout",
    component: () => import("./../views/security/logout.vue"),
    name: "logout",
  },
  {
    path: '/404',
    component: PageNotFound,
    name: '404'
  },
  {
    path: '/403',
    component: PageNotFound,
    name: '403'
  },
  {
    path: '*',
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

Vue.router = router;

export default router;
